<template>
  <div class="text-center full-width-login">
    <div class="fixed-top m-logo">
      <img src="../assets/mxd-white.svg" style="width: 10%" alt="MXD Logo" />
    </div>

    <div v-if="!valid">
      <h3>Reset Password Token has expired.</h3>
      <div>
        <div class="mt-4">
          <router-link
            :to="{ name: 'create-account' }"
            class="mxd-blue-text mr-3 info-text"
            >Create Account </router-link
          >&nbsp;&nbsp;&nbsp;
          <router-link
            :to="{ name: 'login' }"
            class="mxd-blue-text mr-3 info-text"
            >Login</router-link
          >
          <router-link
            :to="{ name: 'forgot-password' }"
            class="mxd-blue-text ml-3 info-text"
            >Forgot Password
          </router-link>
        </div>
      </div>
    </div>

    <div v-else class="form-signin">
      <h3 class="h3 mb-3 header font-weight-normal">Reset Password</h3>
      <label for="username" class="sr-only">Email address</label>
      <input
        type="email"
        id="userEmail"
        disabled
        name="userEmail"
        class="input-control"
        placeholder="Email address"
        v-model="username"
        required
      />
      <input
        type="hidden"
        id="username"
        name="username"
        class="input-control"
        value="<%=username%>"
        required
      />
      <label for="inputPassword" class="sr-only">Password</label>
      <input
        type="password"
        name="password"
        id="inputPassword"
        class="input-control"
        placeholder="Create Password"
        v-model="password"
        required
        autofocus
      />
      <label for="inputConfirmPassword" class="sr-only">Confirm Password</label>
      <input
        type="password"
        name="confirmPassword"
        id="inputConfirmPassword"
        class="input-control form-bottom"
        v-model="confirmPassword"
        placeholder="Confirm Password"
        required
      />
      <div v-if="!passwordsMatch" class="alert alert-danger">
        Passwords don't match.
      </div>
      <div v-if="errorFound" class="alert alert-danger">
        There was an error. Please contact support.
      </div>
      <button
        class="base-button w-100 mt-3"
        type="submit"
        @click="handleSubmit"
      >
        Reset Password
      </button>
      <div class="mt-4">
        <router-link
          :to="{ name: 'login' }"
          class="mxd-blue-text mr-3 info-text"
          >Login</router-link
        >
        <router-link
          :to="{ name: 'create-account' }"
          class="mxd-blue-text ml-3 info-text"
          >Create Account</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: this.$route.params.valid,
      username: this.$route.query.username,
      password: "",
      passwordsMatch: true,
      confirmPassword: "",
      errorFound: false,
    };
  },
  methods: {
    handleSubmit() {
      let t = this;
      if (this.username.length > 0 && this.password == this.confirmPassword) {
        this.$store
          .dispatch("apiEvents/resetPasswordSubmit", {
            username: t.username,
            password: t.password,
          })
          .then((response) => {
            if (response.status == 200) {
              this.$router.push({
                path: "login",
                query: { passwordReset: true },
              });
            }
          })
          .catch(function (error) {
            if (error.response.status == 500) {
              t.errorFound = true;
            }
          });
      } else {
        this.passwordsMatch = false;
      }
    },
  },
};
</script>

<style scoped>
.full-width-login {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 140px;
  padding-bottom: 40px;
}

.mxd-blue-text {
  color: #fff;
}

.mxd-blue-text:hover {
  color: #80ffee;
}

.mxd-blue {
  background-color: #80ffee;
  color: #000;
}

.mxd-blue-text:hover {
  text-decoration: none;
}

.form-signin {
  width: 100%;
  max-width: 350px;
  padding: 15px;
  margin: 0 auto;
  min-width: 325px;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  border-radius: 2px;
}

.form-signin .form-control:focus {
  z-index: 2;
}
</style>
